<script setup>
  import { computed } from 'vue'

  import { useSpotStore } from '@/stores/SpotStore';

  import CurrentConditionsGaugeWindMarker from "@/components/CurrentConditionsGaugeWindMarker.vue";

  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    },
    hideDescription: {
      type: Boolean,
      default: false
    }
  });

  const spotStore = useSpotStore();

  const apiData = computed(() => spotStore.stationApiDataValues);

  const windDescription = computed(() => {
    if (props.hideDescription) return;

    if (props.upgrade[0]) return 'Wind Data Locked';

    if (spotStore.status === 4) return 'Station is Down';

    if (apiData.value.avg === null && (apiData.value.gust === null || apiData.value.gust === 0) && (apiData.value.lull === null || apiData.value.lull === 0)) return 'No Wind Data';

    const baseDescription = apiData.value.avg > 0 ? `${spotStore.formattedData.windAvg} ${spotStore.formattedData.windDirText}` :  `${spotStore.formattedData.windAvg}`;
    const degreesText = apiData.value.avg > 0 && apiData.value.dir ? ` (${spotStore.formattedData.windDir})` : '';

    return `${baseDescription}${degreesText}`;
  })

  const upgrade = computed(() => props.upgrade[0]);
  const windSpeed = computed(() => spotStore.status === 4 ? '<span class="jwx-data-value__value">&ndash;&ndash;</span>' : spotStore.formattedData.windAvgRounded);
  const windDirection = computed(() => spotStore.status === 4 || upgrade.value || apiData.value.avg === 0 ? 0 : apiData.value.dir)
  const windDirectionText = computed(() => {
    if (apiData.value.avg <= 0 || spotStore.status === 4 || upgrade.value ) return '<span class="jwx-data-value__value">&ndash;&ndash;</span>';

    return props.hideDescription ? `${spotStore.formattedData.windDirText}<span class="jwx-data-value__unit">${windDirection.value}&deg;</span>` : spotStore.formattedData.windDirText;
  });
</script>

<template>
  <div
    class="jwx-current-conditions-gauge"
    :class="{'jwx-current-conditions-gauge--hide-description': hideDescription}"
  >
    <p v-if="upgrade" class="jwx-current-conditions-gauge__upgrade">Upgrade to View Wind&nbsp;Data</p>
    <p v-if="!upgrade" v-html="windSpeed" class="jwx-current-conditions-gauge__wind-speed"></p>
    <p v-if="!upgrade" v-html="windDirectionText" class="jwx-current-conditions-gauge__wind-direction"></p>
    <div class="jwx-current-conditions-gauge__wind-gauge">
      <CurrentConditionsGaugeWindMarker
        :iconColor="spotStore.iconColor"
        :iconType="spotStore.iconType"
        :windDir="windDirection"
        :status="spotStore.status"
        :isNowcast="spotStore.isNowcast"
        :upgrade="props.upgrade"
      />
    </div>
    <p v-if="!props.hideDescription" v-html="windDescription" class="jwx-current-conditions-gauge__wind-description"></p>
  </div>
</template>